<!-------------------------------------- Page Layout ---------------------------------------------->
<div class="container">

  <!-------------------------------------- Page Title ---------------------------------------------->
  <h1 class="pageTitle-responsive"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">>
    <span class="icon"><i class="fas fa-truck" aria-hidden="true"></i></span>{{ 'BookingArrive.PageTitle' | translate }}
  </h1>

  <p-tabView [(activeIndex)]="tabMenuActiveIndex">

    <p-tabPanel
      header="{{ 'BookingArrive.TabTitle.BookingArriveTab' | translate }}"
    >
      <ng-content *ngTemplateOutlet="bookingArrive"></ng-content>
    </p-tabPanel>

    <p-tabPanel
      header="{{ 'BookingArrive.TabTitle.DOArriveTab' | translate }}"
    >
      <ng-content *ngTemplateOutlet="DOArrive"></ng-content>
    </p-tabPanel>
  </p-tabView>
</div>

<!-------------------------------------- Booking Arrive ---------------------------------------------->
<ng-template #bookingArrive>

  <p-card>
    <div class="field grid p-fluid">
      <label for="bookingNo" class="col-12" style="max-width:100px">{{ 'BookingArrive.InputLabel.BookingNo' | translate }}</label>
      <div class="col-12 md:col-6 lg:col-4 xl:col-3" style="max-width:250px">
          <p-chips #bookingNoChipsOfBookingArrive
            id="bookingNo" [max]="1" (keydown)="enterBookingNo($event)" [(ngModel)]="bookingNoOfBookingArrive"
          ></p-chips>
      </div>
    </div>
    <button pButton
      class='mr-2' label="{{ 'BookingArrive.Button.ScanningInput' | translate }}" (click)="openScannerDialog()"
    ></button>
    <button pButton
      class='mt-2 mr-2 p-button-danger' label="{{ 'Common.Button.Reset' | translate }}" (click)="onResetButtonClick()"
    ></button>
    <button pButton
      class='mt-2 p-button-warning' style="color: white" label="{{ 'BookingArrive.Button.ArriveConfirm' | translate }}" (click)="onBookingArriveButtonClick()"
    ></button>
  </p-card>

  <div class="py-2"></div>

  <!-------------------------------------- POD Upload ---------------------------------------------->
  <p-card>
    <button pButton class='mr-2' label="{{ 'BookingArrive.Button.Camera' | translate }}" (click)="openCameraDialog(0)"></button>
    <label class="mt-2 mr-2 p-button p-component p-fileupload-choose label-button">
      {{ 'BookingArrive.Button.PhotoUpload' | translate }}
      <input #photoUpload style="display:none" type="file" accept="image/*" (input)="uploadPhoto(photoUpload, 0)"/>
    </label>
    <button pButton class='mt-2 p-button-danger' label="{{ 'BookingArrive.Button.RemovePhoto' | translate }}" (click)="removePhoto(0)"></button>

    <div *ngIf='photoDataUrlOfBookingArrive' class="mt-2">
      <img class="photo-block" alt="POD photo" [src]="photoDataUrlOfBookingArrive" />
    </div>
  </p-card>
</ng-template>

<!-------------------------------------- DO Arrive ---------------------------------------------->
<ng-template #DOArrive>

  <p-card>
    <div class="field grid p-fluid">
      <label for="bookingNo" class="col-12" style="max-width:100px">{{ 'BookingArrive.InputLabel.BookingNo' | translate }}</label>
      <div class="col-12 md:col-6 lg:col-4 xl:col-3" style="max-width:250px">
          <p-chips #bookingNoChipsOfDOArrive
            id="bookingNo" [max]="1" (keydown)="enterBookingNo($event)" [(ngModel)]="bookingNoOfDOArrive"
          ></p-chips>
      </div>
    </div>
    <button pButton
      class='mr-2' label="{{ 'BookingArrive.Button.ScanningInput' | translate }}" (click)="openScannerDialog()"
    ></button>
    <button pButton
      class='mt-2 mr-2 p-button-danger' label="{{ 'Common.Button.Reset' | translate }}" (click)="onResetButtonClick()"
    ></button>
    <button pButton
      class='mt-2 p-button-warning' style='color: white' label="{{ 'BookingArrive.Button.ArriveConfirm' | translate }}" (click)="onBookingArriveButtonClick()"
    ></button>
  </p-card>

  <div class="py-2"></div>

  <p-card>
    <p-table
      [loading]="isPODTableLoading"
      [columns]="columnsOfPODTable" [value]="doNos"
      [resizableColumns]="true" [reorderableColumns]="true"

      [scrollable]="true" scrollHeight="500px"

      [paginator]="true" [paginatorPosition]="isInDesktopMode() ? 'bottom' : 'top'"
      [showCurrentPageReport]="isInDesktopMode()" [showJumpToPageDropdown]="!isInDesktopMode()"
      [showPageLinks]="isInDesktopMode()" [showFirstLastIcon]="isInDesktopMode()"
      currentPageReportTemplate="{{ isInDesktopMode() ? ( 'Common.Table.PageSummary' | translate ) :  '{currentPage} of {totalPages}' }}"
      [rows]="this.rowsPerPageOfPODTable" [rowsPerPageOptions]="this.rowsPerPageOptionsOfPODTable"

      [responsive]="true"
      class="datatable"
      styleClass="p-datatable-gridlines p-datatable-stripped white-space: nowrap;"
    >

      <!-------------------------------------- POD Table Column Group Part ---------------------------------------------->
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup *ngIf="isInDesktopMode()">
          <col *ngFor="let col of columns" style="width: 18vw">
        </colgroup>
      </ng-template>

      <!-------------------------------------- POD Table Column Header Part ---------------------------------------------->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th pReorderableColumn *ngFor="let col of columns"
            [pSortableColumn]="col.field"
            scope="col"
          >
            {{ col.header | translate }}
          </th>
        </tr>
      </ng-template>

      <!-------------------------------------- POD Table Body Part ---------------------------------------------->
      <ng-template pTemplate="body"
        let-rowData let-columns="columns" let-rowIndex="rowIndex"
      >
        <tr>
          <td>
            <div class="tableDataTitle-responsive field">
              {{ columns[0].header | translate }}
            </div>
            <div class="tableData-responsive field">
              {{ rowData | replaceNullWith: "-" }}
            </div>
          </td>

          <td>
            <div class="tableDataTitle-responsive field">
              {{ columns[1].header | translate }}
            </div>
            <button pButton class='mr-2' label="{{ 'BookingArrive.Button.Camera' | translate }}" (click)="openCameraDialog(rowIndex)"></button>
            <label class="mt-2 mr-2 p-button p-component p-fileupload-choose label-button">
              {{ 'BookingArrive.Button.PhotoUpload' | translate }}
              <input #photoUpload style="display:none" type="file" accept="image/*" (input)="uploadPhoto(photoUpload, rowIndex)"/>
            </label>
            <button pButton class='mt-2 p-button-danger' label="{{ 'BookingArrive.Button.RemovePhoto' | translate }}" (click)="removePhoto(rowIndex)"></button>
          </td>

          <td>
            <div class="tableDataTitle-responsive field">
              {{ columns[2].header | translate }}
            </div>
            <div *ngIf='photoDataUrlOfDOArrive[rowIndex]' class="mt-2">
              <img class="photo-block" alt="POD photo" [src]="photoDataUrlOfDOArrive[rowIndex]" />
            </div>
          </td>
        </tr>
        <br *ngIf="!isInDesktopMode()">
      </ng-template>

      <!-------------------------------------- POD Table Empty Message Part ---------------------------------------------->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ 'Common.Table.NoData' | translate }}
          </td>
        </tr>
      </ng-template>

    </p-table>
  </p-card>
</ng-template>

<!-------------------------------------- Scanner Dialog ---------------------------------------------->
<p-dialog #scannerDialog
  header="{{ 'BookingArrive.ScannerDialog.Title' | translate }}"
  appendTo="body" [style]="{width: '70vw'}" [baseZIndex]="100"
  [modal]="true" [draggable]="false" [closeOnEscape]="false"
  (onShow)="openScanner()" (onHide)="onCloseScannerDialog()"
  [(visible)]="showScannerDialog"
>

  <div *ngIf='isScannerLoading' class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div class="scanner-wrapper">
    <p>{{ 'BookingArrive.ScannerDialog.ScanningTitle' | translate }}</p>

    <div class="scanner-line">
      <hr>
    </div>

    <zxing-scanner *ngIf="showScanner"
      (permissionResponse)="checkPermission($event)" (camerasFound)="findScanner($event)"
      [device]="currentScanner" (deviceChange)="onScannerChange($event)"
      [torch]="torchEnabled" (torchCompatible)="onTorchCompatible($event)"
      [formats]="formatsEnabled" (scanSuccess)="afterScan($event)" (scanFailure)="onScanFailure()"
    ></zxing-scanner>
  </div>

  <div>
    <div class="flex justify-content-center align-items-center mt-2">
      <p-dropdown
        class="mr-2" appendTo="body" [baseZIndex]="1000" [(ngModel)]="currentScanner"
        [options]="availableDevices" optionLabel='label'
        (onChange)="onSelectedScannerChange()"
      ></p-dropdown>
      <button pButton *ngIf="torchAvailable | async"
        icon="pi pi-filter"
        [ngClass]="torchEnabled ? 'p-button-rounded' : 'p-button-rounded p-button-outlined'"
        (click)="toggleTorch()">
      </button>
    </div>
  </div>

</p-dialog>

<!-------------------------------------- Camera Diaog ---------------------------------------------->
<p-dialog #cameraDialog
  header="{{ 'BookingArrive.CameraDialog.Title' | translate }}"
  appendTo="body" [style]="{width: '70vw'}" [baseZIndex]="100"
  [modal]="true" [draggable]="false" [closeOnEscape]="false"
  (onShow)="openCamera()" (onHide)="closeCamera()"
  [(visible)]="showCameraDialog"
>

  <div *ngIf='isCameraLoading' class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <!-------------------------------------- allowCameraSwitch:false -> don't use default switch button ---------------------------------------------->
  <div class="camera-wrapper flex justify-content-center align-items-center">
    <webcam *ngIf="showCamera"
      [imageQuality]="1" mirrorImage="never" [allowCameraSwitch]="false"
      [trigger]="triggerObservable" [switchCamera]="nextWebcamObservable"
      (imageCapture)="handleImage($event)" (initError)="handleInitError($event)"
      (cameraSwitched)="afterCameraStandby()"
    ></webcam>
  </div>

  <div class="flex justify-content-center mt-2">
    <button pButton
      class="mr-2" label="{{'BookingArrive.CameraDialog.Button.Snapshot' | translate }}" (click)="triggerSnapshot()"
    ></button>
    <button pButton
      label="{{'BookingArrive.CameraDialog.Button.SwitchCamera' | translate }}" (click)="switchToNextCamera(true);"
      [disabled]="!isMultiCamerasAvailable"
    ></button>
  </div>

</p-dialog>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
